<template>
  <el-dialog
    title="报警信息"
    :visible.sync="dialogTableVisible"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-table :data="responseData.list" height="450">
      <!-- <el-table-column property="id" label="ID" width="60"></el-table-column> -->

      <el-table-column
        property="captureTime"
        label="报警编号"
        width="120"
      ></el-table-column>

      <el-table-column property="identificationType" label="报警类型">
        <template slot-scope="scope">
          <div v-if="scope.row.identificationType == 1">陌生人预警</div>
          <div v-if="scope.row.identificationType == 2">疑似学生家长</div>
        </template>
      </el-table-column>
      <el-table-column property="urlOfCapturedImage" label="抓拍图片">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.urlOfCapturedImage"
            :preview-src-list="[scope.row.urlOfCapturedImage]"
          >
          </el-image>
        </template>
      </el-table-column>
      <!-- <el-table-column property="captureTime" label="预警时间" width="200">
        <template slot-scope="scope">
          {{ $Common.dateFormatDateTwo(scope.row.captureTime) }}
        </template>
      </el-table-column> -->
    </el-table>
    <div
      class="inside_pages_right_content_bottom"
      v-if="responseData.total > 0"
    >
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="responseData.pageNum"
        :page-sizes="[20, 30, 50, 100]"
        :page-size="20"
        layout="total, sizes, prev, pager, next, jumper"
        prev-text="上一页"
        next-text="下一页"
        :total="responseData.total"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "faceDeviceAlert",
  components: {},
  props: {
    deviseSerialNumber: {
      type: String,
      default: {
        return: ""
      }
    },
    selResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      reqData: {
        pageSize: 20,
        pageNum: 1,
        cameraSerialNumber: ""
      },
      // 数据列表
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      dialogTableVisible: false
    };
  },
  created() {},
  mounted() {},
  watch: {
    selResize: function(newVal) {
      this.reqData.cameraSerialNumber = this.deviseSerialNumber;
      this.getFaceDeviceAlert();
    }
  },
  computed: {},
  methods: {
    handleSizeChange(val) {
      this.reqData.pageSize = val;
      this.getFaceDeviceAlert();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      this.getFaceDeviceAlert();
      console.log(`当前页: ${val}`);
    },
    async getFaceDeviceAlert() {
      let req = this.reqData;
      let res = await this.$Http.getFaceDeviceAlert(req, true);
      if (res.code == 200) {
        this.responseData = res.data;
        this.dialogTableVisible = true;
      } else if (res.code == 101) {
        this.$message("暂时没有报警信息记录！");
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
